import React, { useState } from 'react';
import { compose } from 'redux';
import { NamedRedirect } from '..';
import { ResponsiveImage, Avatar, Button, HorizontalScroll } from '../../components';
import { formatMoney } from '../../util/currency';
import { createSlug } from '../../util/urlHelpers';
import { getRatingFromReviews } from 'containers/ListingPage/helper';
import { ensurePrice } from 'util/data';
import { withViewport } from '../../util/contextHelpers';
import css from './PromotedListing.css';
import classNames from 'classnames';
import Flipcard from './Flipcard/Flipcard';
import ListingFlipCard from './ListingFlipCard/ListingFlipCard';
import { defaultListingCurrency } from '../../util/types';
import SectionMapMaybe from 'containers/ListingPage/SectionMapMaybe';
import starRatingIcon from '../../assets/HomePage/starRatingIcon.svg';
import Price from 'react-price';
import moment from 'moment';
import { createResourceLocatorString, openLinkNewTab } from 'util/routes';
import routeConfiguration from 'routeConfiguration';

const priceData = (price, intl, discount) => {
  if (price && defaultListingCurrency.includes(price.currency) && discount === 'discount') {
    const minusPrice = (price.amount * 10) / 100;
    const discountFormattedPrice = price.amount - minusPrice;
    const discountObj = { ...price, amount: discountFormattedPrice };
    const discountEnsurePrice = ensurePrice(discountObj);
    const discountPrice = formatMoney(intl, discountEnsurePrice, 2, 2);
    return { discountPrice, priceTitle: discountPrice };
  } else if (price && defaultListingCurrency.includes(price.currency)) {
    const formattedPrice = formatMoney(intl, price, 2, 2);
    return { formattedPrice, priceTitle: formattedPrice };
  } else if (price) {
    return {
      formattedPrice: `(${price.currency})`,
      priceTitle: `Unsupported currency (${price.currency})`,
    };
  }
  return {};
};

const PromotedListing = props => {
  const {
    pl,
    intl,
    chargebeeData,
    isHorizontalLayout,
    viewport,
    listingAllReviews,
    newReviews,
    showMap = false,
    isEducationSite,
    isTennisSite,
    isMobileLayout,
  } = props;

  const reviews = listingAllReviews ? listingAllReviews[pl.id.uuid] : [];
  const [isRedirect, setRedirect] = useState(false);
  const title = pl.attributes.title;
  const description = pl.attributes?.description;
  const author = pl.author;
  const providerName = pl.attributes.publicData?.provider_name;
  const images = pl?.images || [];
  const id = pl.id.uuid;
  const slug = createSlug(pl.attributes.title);
  const rating = getRatingFromReviews(reviews).toFixed(2);
  const totalBooking = pl.attributes.publicData?.total_bookings || 0;
  const address = pl.attributes?.publicData?.location?.address;
  const price = pl.attributes?.price;
  const ratings = pl.attributes.publicData.rating;
  const otherImages = pl?.images?.slice(0, 6);
  // const unique_features = pl?.attributes?.publicData?.unique_features || 'No Unique Features';
  // const why_choose_us = pl?.attributes?.publicData?.why_choose_us || 'Not defined';
  // const about_location =
  //   pl?.attributes?.publicData?.about_location || 'About location is not defined';
  const currentPrice = ensurePrice(price);
  const { formattedPrice } = priceData(currentPrice, intl);

  const { discountPrice } = priceData(currentPrice, intl, 'discount');
  const isHorizontalCard = !isHorizontalLayout && (viewport.width ? viewport.width <= 1199 : false);

  const getOtherAuthorListing = (listingId, authorId) => {
    return props.promotedListings?.filter(
      data => data.id.uuid !== listingId && data.author?.id.uuid === authorId
    );
  };
  const todayDate = moment(new Date()).format('MM/DD/YYYY');
  // console.log(props.promotedListings?.length, 'props.promotedListings');
  // console.log(
  //   props.promotedListings?.filter(
  //     data => data.author?.id.uuid === '6347586d-15c5-4d44-9689-43b4e78e3f1e'
  //   ),
  //   'props.promotedListings'
  // );

  const listingUrl = createResourceLocatorString(
    'ListingPage',
    routeConfiguration(),
    { id, slug },
    {}
  );

  const openLinkNewTabFun = () => {
    setRedirect(false);
    let tempListingUrl;

    if (listingUrl !== tempListingUrl) {
      tempListingUrl = listingUrl;
      openLinkNewTab(listingUrl);
    }
  };

  return isRedirect ? (
    // isMobileLayout ? (
    <NamedRedirect name="ListingPage" params={{ id, slug }} />
  ) : (
    // ) : (
    //   openLinkNewTabFun()
    // )
    <>
      {!isHorizontalCard && showMap ? (
        <div className={css.cardListingBox} onClick={() => setRedirect(true)}>
          <div className={css.cardImageWrapper}>
            <div className={css.cardMiniImage}>
              <ResponsiveImage
                src={images[0]}
                alt={title}
                image={images[0]}
                variants={['scaled-small', 'square-small2x']}
              />
            </div>

            <div className={css.cardMiniImage}>
              <ResponsiveImage
                src={images[1]}
                alt={title}
                image={images[1]}
                variants={['scaled-small', 'square-small2x']}
              />
            </div>

            <div className={css.cardMiniImage}>
              <ResponsiveImage
                src={images[2]}
                alt={title}
                image={images[2]}
                variants={['scaled-small', 'square-small2x']}
              />
            </div>
          </div>

          <div>
            <Avatar rootClassName={css.authorProfileImage} user={author} disableProfileLink />
          </div>

          <div className={css.cardTitleText}>
            <h4 className={css.cardTitleName}>{providerName}</h4>
            <div className={css.cardLocation}>
              <svg
                width="8"
                height="10"
                viewBox="0 0 8 10"
                fill="none"
                xmlns="http://www.w3.org/2000/svg"
              >
                <path
                  d="M3.68532 9.77716C3.02599 9.21276 2.41485 8.59401 1.85828 7.92738C1.02307 6.92627 0.0312505 5.43534 0.0312505 4.01462C0.0308882 3.28904 0.245018 2.57966 0.64654 1.97626C1.04806 1.37286 1.61893 0.902558 2.28689 0.624876C2.95485 0.347194 3.68989 0.274614 4.39897 0.416321C5.10805 0.558028 5.7593 0.907652 6.27031 1.42095C6.61053 1.76086 6.8802 2.16512 7.06371 2.61032C7.24721 3.05552 7.34091 3.53283 7.33939 4.01462C7.33939 5.43534 6.34757 6.92627 5.51235 7.92738C4.95579 8.59401 4.34465 9.21276 3.68532 9.77716ZM3.68532 2.44301C3.26998 2.44301 2.87166 2.60859 2.57797 2.90332C2.28428 3.19806 2.11929 3.5978 2.11929 4.01462C2.11929 4.43143 2.28428 4.83117 2.57797 5.12591C2.87166 5.42064 3.26998 5.58622 3.68532 5.58622C4.10066 5.58622 4.49898 5.42064 4.79267 5.12591C5.08636 4.83117 5.25135 4.43143 5.25135 4.01462C5.25135 3.5978 5.08636 3.19806 4.79267 2.90332C4.49898 2.60859 4.10066 2.44301 3.68532 2.44301Z"
                  fill="#0058FA"
                />
              </svg>
              <span className={css.cardAddress}>{address}</span>
            </div>

            <div className={css.cardsParagraph}>
              <span className={css.cardsParagraphSpan}>{description}</span>
            </div>

            <div className={css.cardsRatings}>
              <div className={css.cardsRatingNumber}>
                <h6 className={css.cardsRatingPluse}>{totalBooking}</h6>
                <span className={css.cardsRatingTitle}>Bookings</span>
              </div>
              <div className={css.cardsRatingNumber}>
                <h6 className={css.cardsRatingPluse}>{rating}</h6>
                <span className={css.cardsRatingTitle}>Ratings</span>
              </div>
              <div className={css.cardsRatingNumber}>
                <h6 className={css.cardsRatingPluse}>3.5k</h6>
                <span className={css.cardsRatingTitle}>Views</span>
              </div>
            </div>

            <div className={css.cardsButton}>
              <h4 className={css.price}>{formattedPrice}</h4>
              <Button onClick={() => setRedirect(true)} rootClassName={css.viewOfferButton}>
                View Offers
              </Button>
            </div>
          </div>
        </div>
      ) : !isHorizontalCard ? (
        <Flipcard
          description={description}
          images={images}
          ratings={ratings}
          formattedPrice={formattedPrice}
          newReviews={newReviews}
          pl={pl}
          ListingId={id}
          author={author}
          getOtherAuthorListing={getOtherAuthorListing}
          title={title}
          address={address}
          discountPrice={discountPrice}
          chargebeeData={chargebeeData}
          setRedirect={setRedirect}
          isEducationSite={isEducationSite}
          // isTennisSite={isTennisSite}
        />
      ) : // <Flipcard
      //   description={description}
      //   images={images}
      //   ratings={ratings}
      //   formattedPrice={formattedPrice}
      //   newReviews={newReviews}
      //   pl={pl}
      //   ListingId={id}
      //   author={author}
      //   getOtherAuthorListing={getOtherAuthorListing}
      //   title={title}
      //   address={address}
      //   discountPrice={discountPrice}
      //   chargebeeData={chargebeeData}
      //   setRedirect={setRedirect}
      //   isEducationSite={isEducationSite}
      //   isTennisSite={isTennisSite}
      // />
      isHorizontalCard ? (
        <div className={css.slider} onClick={() => setRedirect(true)}>
          <HorizontalScroll
            scrollClassName={css.newScroll}
            isSmallScrollArrow={true}
            className={classNames(css.categoryListContainer, {
              [css.categoryListContainerWithoutArrow]:
                typeof window !== 'undefined' ? window.screen.width <= 425 : true,
            })}
          >
            <div className={css.sliderWrap}>
              <div className={css.trainerMainWrapper}>
                <div
                  className={classNames(
                    css.trainerSectionWrap,
                    isEducationSite && css.trainerSectionWrapedu
                  )}
                  onClick={() => setRedirect(true)}
                >
                  <ResponsiveImage
                    src={pl.images[0]}
                    alt="authorProfileImg"
                    image={pl.images[0]}
                    variants={['scaled-small', 'square-small', 'square-small2x']}
                  />
                </div>
                <div className={css.trainerDetailMain}>
                  <div className={css.trainerDetailWrap}>
                    <div className={css.subCategoryWrap}>
                      {pl.attributes.publicData.sub_category instanceof Array ? (
                        pl.attributes.publicData?.sub_category?.slice(0, 3)?.map((subCat, i) => (
                          <span key={i} className={css.subCategoryText}>
                            {subCat}
                          </span>
                        ))
                      ) : (
                        <span className={css.subCategoryText}>
                          {pl.attributes.publicData.sub_category}
                        </span>
                      )}
                    </div>
                    <div className={css.trainerDetailTitle} onClick={() => setRedirect(true)}>
                      {title}
                    </div>
                    <div className={css.ratingLocationWrapper} onClick={() => setRedirect(true)}>
                      <div className={css.ratingWrap}>
                        <div className={css.ratingTextWrap}>
                          <img src={starRatingIcon} alt={' '} />
                          <span className={css.ratingText}>{ratings?.toFixed(2)}</span>
                        </div>
                      </div>
                      <div className={css.locationWrap}>
                        <div className={css.locationTextWrap}>
                          <svg
                            width="12"
                            height="16"
                            viewBox="0 0 12 16"
                            fill="none"
                            xmlns="http://www.w3.org/2000/svg"
                          >
                            <path
                              d="M6.24479 15.5361C5.21174 14.6551 4.25419 13.6892 3.38216 12.6487C2.07353 11.086 0.519532 8.7587 0.519532 6.54099C0.518964 5.4084 0.854466 4.30109 1.48358 3.3592C2.11269 2.41732 3.00713 1.68319 4.05371 1.24974C5.10028 0.816293 6.25195 0.702998 7.36295 0.924197C8.47395 1.1454 9.49435 1.69115 10.295 2.49238C10.8281 3.02297 11.2506 3.654 11.5381 4.34895C11.8256 5.04389 11.9724 5.78894 11.97 6.54099C11.97 8.7587 10.4161 11.086 9.10742 12.6487C8.23538 13.6892 7.27784 14.6551 6.24479 15.5361ZM6.24479 4.08778C5.59403 4.08778 4.96993 4.34625 4.50978 4.80631C4.04962 5.26638 3.79111 5.89036 3.79111 6.54099C3.79111 7.19163 4.04962 7.81561 4.50978 8.27568C4.96993 8.73574 5.59403 8.9942 6.24479 8.9942C6.89555 8.9942 7.51965 8.73574 7.97981 8.27568C8.43996 7.81561 8.69847 7.19163 8.69847 6.54099C8.69847 5.89036 8.43996 5.26638 7.97981 4.80631C7.51965 4.34625 6.89555 4.08778 6.24479 4.08778Z"
                              fill="#0058FA"
                            />
                          </svg>

                          <span className={css.locationMainText}>{address}</span>
                        </div>
                      </div>
                    </div>

                    <div className={css.trainerDetailDesc} onClick={() => setRedirect(true)}>
                      {description}
                    </div>
                    {/* // if you want to show map than make display: flex to none */}
                    <div className={css.aboutLocationWrapper}>
                      {isEducationSite ? (
                        ''
                      ) : (
                        <SectionMapMaybe
                          geolocation={pl?.attributes?.geolocation}
                          publicData={pl?.attributes?.publicData}
                          rootClassName={css.mapImage}
                          isStatic={true}
                          listingId={pl?.id}
                          zoom={13}
                        />
                      )}
                    </div>
                  </div>
                </div>
              </div>
            </div>

            <div className={css.gallerItemsWrap}>
              {otherImages &&
                otherImages.slice(0, 4).map((image, index) => {
                  return (
                    <div key={index} className={css.gallerItems}>
                      <ResponsiveImage
                        className={css.itemImg}
                        src={image}
                        image={image}
                        variants={['scaled-small', 'scaled-small2x']}
                        alt={'title'}
                      />
                    </div>
                  );
                })}
            </div>

            {/* <div className={css.featuresImgWrapper}>
              <div className={css.featuresMainWrap}>
                <div className={css.listingsMain}>
                  <h6 className={css.listingsHead}>Total Listings</h6>
                  <p className={css.listingsText}>
                    {getOtherAuthorListing(id, author?.id?.uuid)?.length}
                  </p>
                </div>
                <div className={css.featuresMain}>
                  <div className={css.features}>
                    <svg
                      width="19"
                      height="18"
                      viewBox="0 0 19 18"
                      fill="none"
                      xmlns="http://www.w3.org/2000/svg"
                      className={css.featuresImg}
                    >
                      <g clip-path="url(#clip0_5430_459)">
                        <path
                          d="M3.53267 10.1947L0.484509 9.58575C0.441119 9.57729 0.396399 9.57851 0.353535 9.58932C0.310672 9.60013 0.27072 9.62026 0.236527 9.64828C0.202334 9.6763 0.174743 9.71151 0.155718 9.75141C0.136694 9.79132 0.126706 9.83492 0.126465 9.87913L0.126465 15.8665C0.126465 15.9459 0.158005 16.022 0.214148 16.0782C0.27029 16.1343 0.346435 16.1659 0.425833 16.1659H2.77048C3.02246 16.1647 3.26568 16.0733 3.45604 15.9082C3.6464 15.7431 3.7713 15.5152 3.80809 15.266L4.36491 11.3706C4.40226 11.1054 4.33691 10.836 4.18221 10.6174C4.02752 10.3988 3.79517 10.2476 3.53267 10.1947ZM15.6936 12.8728C15.2493 12.8728 14.0189 13.2201 13.5076 13.3698C13.4433 13.3887 13.3873 13.4287 13.3484 13.4833C13.3095 13.5379 13.2901 13.604 13.2933 13.6709C13.2951 13.7158 13.2963 13.7547 13.2957 13.7715C13.2639 14.3182 13.0232 14.7762 12.5927 15.1037C12.1455 15.445 11.5354 15.6102 10.7277 15.6102C9.80083 15.6102 8.60456 15.3893 7.0706 14.936C6.92092 14.8917 6.81674 14.7427 6.84667 14.5894C6.85434 14.5481 6.87059 14.5089 6.89437 14.4744C6.91816 14.4398 6.94895 14.4106 6.98474 14.3887C7.02053 14.3668 7.06053 14.3527 7.10214 14.3472C7.14375 14.3418 7.18604 14.3451 7.22627 14.3571C9.85592 15.1366 11.4498 15.221 12.2305 14.6271C12.5502 14.3834 12.7083 14.0433 12.6999 13.6152C12.6967 13.4949 12.6749 13.3757 12.6353 13.262C12.6293 13.2452 12.6257 13.2279 12.6191 13.2111C12.3035 12.4028 11.0863 12.0831 9.84095 11.8304C9.18953 11.6987 8.70635 11.4831 8.23933 11.2742C7.66574 11.0185 7.12329 10.7772 6.41319 10.7772C6.05275 10.7772 5.66956 10.797 5.24086 10.8395C5.16508 10.8469 5.09497 10.8829 5.04481 10.9402C4.99464 10.9975 4.96819 11.0717 4.97083 11.1478C4.97503 11.249 4.97203 11.3514 4.95647 11.455L4.39964 15.3498C4.39046 15.4151 4.40308 15.4816 4.43556 15.5389C4.46804 15.5963 4.51856 15.6414 4.57926 15.6671C6.39523 16.4413 8.86322 17.3633 10.305 17.3633C11.8922 17.3633 15.3942 15.7791 17.276 14.9277C17.5305 14.8127 17.7449 14.7163 17.9077 14.6445C17.9626 14.6198 18.0091 14.5795 18.0412 14.5286C18.0734 14.4777 18.0898 14.4185 18.0885 14.3583C18.0784 13.4404 16.8408 12.8728 15.6936 12.8728Z"
                          fill="#0058FA"
                        />
                        <path
                          d="M15.6205 3.19897C16.5234 3.02115 17.3664 2.9942 17.7885 2.9942C17.8679 2.9942 17.9441 3.02574 18.0002 3.08188C18.0564 3.13803 18.0879 3.21417 18.0879 3.29357C18.0879 5.03948 17.5652 6.49082 16.5755 7.4919C15.5983 8.48042 14.1931 8.98156 12.3999 8.98156C10.6067 8.98156 9.20146 8.47982 8.22372 7.4919C7.23461 6.49082 6.71191 5.03948 6.71191 3.29357C6.71191 3.21417 6.74345 3.13803 6.7996 3.08188C6.85574 3.02574 6.93188 2.9942 7.01128 2.9942C7.7388 2.99442 8.46468 3.06318 9.1793 3.19957C9.24973 3.21356 9.31279 3.25239 9.35698 3.309C9.40116 3.3656 9.42353 3.4362 9.42 3.50792C9.40871 3.68651 9.40671 3.86618 9.41401 4.04498C9.46459 5.03171 9.80027 5.9826 10.3804 6.7824C10.1672 6.29204 10.0415 5.76455 10.0115 5.21012C9.92293 3.54085 10.724 1.88475 12.2101 0.666917C12.2636 0.623039 12.3307 0.59906 12.3999 0.59906C12.4691 0.59906 12.5362 0.623039 12.5897 0.666917C14.0758 1.88475 14.8769 3.54085 14.7883 5.21012C14.7583 5.76455 14.632 6.29204 14.4194 6.783C14.9996 5.98301 15.3353 5.03191 15.3858 4.04498C15.396 3.86476 15.3882 3.68574 15.3792 3.50732C15.3757 3.43551 15.3982 3.36485 15.4425 3.30823C15.4868 3.25161 15.55 3.21283 15.6205 3.19897Z"
                          fill="#FAB400"
                        />
                      </g>
                      <defs>
                        <clipPath id="clip0_5430_459">
                          <rect
                            width="17.9621"
                            height="17.9621"
                            fill="white"
                            transform="translate(0.126465)"
                          />
                        </clipPath>
                      </defs>
                    </svg>

                    <h6 className={css.featuresHead}>Unique Features</h6>
                  </div>
                  <p className={css.featuresText}>{unique_features}</p>
                </div>
                <div className={css.featuresMain}>
                  <div className={css.features}>
                    <svg
                      width="22"
                      height="23"
                      viewBox="0 0 22 23"
                      fill="none"
                      xmlns="http://www.w3.org/2000/svg"
                      className={css.featuresImg}
                    >
                      <path
                        fill-rule="evenodd"
                        clip-rule="evenodd"
                        d="M18.3333 8.33024C19.3459 8.33024 20.1667 7.49184 20.1667 6.45756C20.1667 5.42328 19.3459 4.58488 18.3333 4.58488C17.3208 4.58488 16.5 5.42328 16.5 6.45756C16.5 7.49184 17.3208 8.33024 18.3333 8.33024ZM19.5747 9.58537C20.3683 9.58537 20.9967 9.9493 21.4074 10.5125C21.7919 11.0397 21.9546 11.6926 21.9915 12.2945C22.0288 12.9057 21.9423 13.5463 21.7491 14.1169C21.5649 14.6603 21.2554 15.2221 20.7778 15.6074V21.7511C20.7778 22.2383 20.412 22.6441 19.9367 22.6843C19.4614 22.7245 19.0353 22.3856 18.9569 21.9051L18.1679 17.0694H17.9865L17.0954 21.9237C17.0082 22.3989 16.581 22.7282 16.1096 22.6835C15.6383 22.6387 15.2778 22.2346 15.2778 21.7511V12.8451C15.209 12.9523 15.1452 13.0526 15.089 13.1419C15.0166 13.2568 14.9571 13.3523 14.9159 13.4189L14.8685 13.4957L14.8564 13.5154L14.8529 13.5213C14.6855 13.7957 14.3912 13.9626 14.0747 13.9626H11.0192C10.5129 13.9626 10.1025 13.5435 10.1025 13.0263C10.1025 12.5092 10.5129 12.09 11.0192 12.09H13.5716C13.7198 11.8554 13.9153 11.5509 14.1208 11.2447C14.3348 10.9256 14.5708 10.588 14.7805 10.3237C14.8829 10.1944 14.9975 10.0593 15.1123 9.94849C15.1685 9.8943 15.247 9.82414 15.3419 9.7619C15.4097 9.71752 15.6185 9.58537 15.9081 9.58537H19.5747Z"
                        fill="#0058FA"
                      />
                      <path
                        fill-rule="evenodd"
                        clip-rule="evenodd"
                        d="M0 0H18.7647V3.08926H17.5541V1.2357H1.21063V15.4463H14.1565V16.682H0V0Z"
                        fill="#FFB81D"
                      />
                    </svg>

                    <h6 className={css.featuresHead}>Why Choose Us</h6>
                  </div>
                  <p className={css.featuresText}>{why_choose_us}</p>
                </div>
                <div className={css.featuresMain}>
                  <div className={css.features}>
                    <svg
                      className={css.featuresImg}
                      width="13"
                      height="15"
                      viewBox="0 0 13 15"
                      fill="none"
                      xmlns="http://www.w3.org/2000/svg"
                    >
                      <path
                        d="M6.51962 14.7669C5.51681 13.9117 4.58728 12.9741 3.74077 11.9639C2.47044 10.447 0.961915 8.18781 0.961915 6.03501C0.961364 4.93556 1.28705 3.86066 1.89775 2.94633C2.50845 2.03201 3.37672 1.31938 4.39266 0.898611C5.40861 0.477846 6.52657 0.367867 7.60506 0.582592C8.68355 0.797318 9.67408 1.3271 10.4513 2.10488C10.9688 2.61995 11.3789 3.23251 11.658 3.90712C11.9371 4.58172 12.0797 5.30497 12.0773 6.03501C12.0773 8.18781 10.5688 10.447 9.29848 11.9639C8.45196 12.9741 7.52244 13.9116 6.51962 14.7669ZM6.51962 3.6536C5.88791 3.6536 5.28207 3.90449 4.83538 4.3511C4.3887 4.7977 4.13775 5.40342 4.13775 6.03501C4.13775 6.6666 4.3887 7.27233 4.83538 7.71893C5.28207 8.16553 5.88791 8.41643 6.51962 8.41643C7.15134 8.41643 7.75718 8.16553 8.20386 7.71893C8.65055 7.27233 8.9015 6.6666 8.9015 6.03501C8.9015 5.40342 8.65055 4.7977 8.20386 4.3511C7.75718 3.90449 7.15134 3.6536 6.51962 3.6536Z"
                        fill="#FFB81D"
                      />
                    </svg>

                    <h6 className={css.featuresHead}>About the Location </h6>
                  </div>
                  <p className={css.featuresText}>{about_location}</p>
                </div>
              </div>
            </div> */}
          </HorizontalScroll>
          <div className={css.promotedBookingWrapper}>
            <button className={css.cardDetailButton}>Book Now</button>
            <div className={css.priceWrapper}>
              <div className={css.priceFrom}>From</div>
              {/* <div className={css.priceProduct}>{formattedPrice}</div> */}
              <div className={css.priceProduct}>
                {chargebeeData?.ChargebeeId && todayDate <= chargebeeData?.FutureDate ? (
                  <>
                    <Price cost={formattedPrice} type="old" />
                    <Price cost={discountPrice} />
                  </>
                ) : (
                  <Price cost={formattedPrice} />
                )}
              </div>
            </div>
          </div>
        </div>
      ) : (
        <div className={css.cardMain} onClick={() => setRedirect(true)}>
          <div className={css.cardImgMain}>
            <ResponsiveImage
              src={images[0]}
              alt="authorProfileImg"
              image={images[0]}
              variants={['scaled-small', 'square-small', 'square-small2x']}
            />
          </div>
          <div className={css.cardwrap}>
            <div className={css.cardDetailsWrap}>
              <h3 className={css.cardDetailsHead}>{title}</h3>
              <div className={css.cardDetailAddressWrap}>
                <div className={css.cardDetailAddress}>
                  <svg
                    width="14"
                    height="12"
                    viewBox="0 0 14 12"
                    fill="none"
                    xmlns="http://www.w3.org/2000/svg"
                  >
                    <path
                      d="M7.90978 0.676692L9.18184 3.79901L12.5707 4.04394C13.3724 4.12275 13.6309 5.08652 13.0351 5.50913L10.3984 7.65952L11.2081 10.8946C11.3794 11.6658 10.5236 12.2042 9.92983 11.7796L7.02766 9.98656L4.13901 11.7405C3.44371 12.1387 2.65656 11.5075 2.88532 10.8229L3.72897 7.56372L1.13355 5.41299C0.533221 4.88779 0.902014 3.95901 1.63717 3.96037L5.05995 3.73956L6.34484 0.656309C6.66892 -0.0659236 7.68449 -0.0091913 7.90978 0.676692Z"
                      fill="#FFB534"
                    />
                  </svg>
                  <span className={css.cardDetailAddressText}>{ratings?.toFixed(2)}</span>
                </div>
                <div className={css.cardDetailAddress}>
                  <svg
                    width="12"
                    height="15"
                    viewBox="0 0 12 15"
                    fill="none"
                    xmlns="http://www.w3.org/2000/svg"
                  >
                    <path
                      d="M5.97166 14.6659C4.98269 13.8225 4.06601 12.8979 3.23119 11.9017C1.97841 10.4057 0.490723 8.17771 0.490723 6.05465C0.49018 4.97039 0.811365 3.91033 1.41363 3.00864C2.01589 2.10695 2.87217 1.40416 3.87408 0.989203C4.87599 0.57425 5.97851 0.46579 7.0421 0.67755C8.10569 0.889309 9.08254 1.41177 9.84903 2.17881C10.3593 2.68676 10.7638 3.29086 11.0391 3.95615C11.3143 4.62143 11.4549 5.3347 11.4526 6.05465C11.4526 8.17771 9.96491 10.4057 8.71213 11.9017C7.87731 12.8979 6.96062 13.8225 5.97166 14.6659ZM5.97166 3.70613C5.34867 3.70613 4.7512 3.95356 4.31068 4.394C3.87017 4.83443 3.62269 5.43178 3.62269 6.05465C3.62269 6.67752 3.87017 7.27487 4.31068 7.71531C4.7512 8.15574 5.34867 8.40317 5.97166 8.40317C6.59465 8.40317 7.19212 8.15574 7.63263 7.71531C8.07315 7.27487 8.32063 6.67752 8.32063 6.05465C8.32063 5.43178 8.07315 4.83443 7.63263 4.394C7.19212 3.95356 6.59465 3.70613 5.97166 3.70613Z"
                      fill="#0058FA"
                    />
                  </svg>
                  <span className={css.cardDetailAddressText}>{address}</span>
                </div>
              </div>
              <p className={css.cardDetailText}>{description}</p>
              <div className={css.bookingWrapper}>
                <button className={css.cardDetailButton}>Book Now</button>
                <div className={css.priceWrapper}>
                  <div className={css.priceFrom}>From</div>
                  <div className={css.priceProduct}>{formattedPrice}</div>
                </div>
              </div>
            </div>
            <div className={css.cardImagesWrap}>
              {images &&
                images.slice(0, 4).map((image, i) => {
                  return (
                    <div key={i} className={css.cardImgWrapper}>
                      <ResponsiveImage
                        className={css.itemImg}
                        src={image}
                        image={image}
                        variants={['scaled-small', 'scaled-small2x']}
                        alt="title"
                      />
                    </div>
                  );
                })}
            </div>
          </div>
        </div>
      )}
    </>
  );
  // );
};

export default compose(withViewport)(PromotedListing);
